"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupViewStyled = void 0;
exports.GroupViewStyled = styled.div.attrs({ className: 'octo' }) `
&.octo {
  display: flex;
  flex-flow: column nowrap;
  gap: 1.5em;
  align-items: stretch;
  justify-content: flex-start;
}
`;
//# sourceMappingURL=GroupView.styled.js.map